import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { buildOrgPath, PATHS } from "@constants/Paths";
import { useAnalytics } from "@piiqtechnologies/ui-lib";
import { PeekStack } from "@piiqtechnologies/ui-components";
import { useOptionalActiveOrganization } from "@stores/ActiveOrganizationContext";
import { AnalyticsArea } from "@hooks";
import { StorylaneTourDialog } from "../storylane-tour-dialog";
import { ReportTypeBox } from "./report-type-box";
import { getReportTypesText } from "./constants/reportTypes";
export const ReportTypes = ({ onPlanSelect, billingPeriod = "annually", prices, basicFirstReportFreePromo, }) => {
    const intl = useIntl();
    const navigate = useNavigate();
    const analytics = useAnalytics();
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    const [previewPlanId, setPreviewPlanId] = useState(null);
    // Dual-context: mounted both under ActiveOrgLayout (pages/report-type, no onPlanSelect — the
    // navigate() below fires) and under AdminHome/DashboardLayout via ReportTypesPricing (always
    // passes onPlanSelect, so navigate() here never runs there). Never throwing.
    const activeOrgContext = useOptionalActiveOrganization();
    const reportTypesText = getReportTypesText(intl, billingPeriod, prices, { basicFirstReportFreePromo });
    const handlePlanSelect = (reportType) => {
        analytics === null || analytics === void 0 ? void 0 : analytics.track("Ai Discoverability || Report Plan Selected", {
            planId: reportType.id,
            planTitle: reportType.title,
        });
        if (reportType.id === "enterprise") {
            window.open("https://www.peek.us/contact", "_blank", "noopener,noreferrer");
            return;
        }
        if (onPlanSelect) {
            onPlanSelect(reportType);
            return;
        }
        const checkoutPath = activeOrgContext ? buildOrgPath(activeOrgContext.activeOrgId, PATHS.CHECKOUT) : PATHS.CHECKOUT;
        navigate(`${checkoutPath}?plan=${encodeURIComponent(reportType.id)}&billing=${billingPeriod}`);
    };
    const handlePreview = (reportType) => {
        setPreviewPlanId(reportType.id);
        setIsPreviewOpen(true);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekStack, { direction: { xs: "column", lg: "row" }, gap: 3.5, alignSelf: "center", alignItems: "center" }, reportTypesText.map((reportType) => (React.createElement(PeekStack, { key: reportType.id, width: "100%" },
            React.createElement(ReportTypeBox, { reportType: reportType, onSelect: () => handlePlanSelect(reportType), onPreview: reportType.previewLabel ? () => handlePreview(reportType) : undefined }))))),
        React.createElement(StorylaneTourDialog, { open: isPreviewOpen, onClose: () => setIsPreviewOpen(false), analyticsArea: AnalyticsArea.Billing, analyticsAction: "Report Preview", trackProps: { planId: previewPlanId, billingPeriod } })));
};
export default ReportTypes;
